 /*
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

import {AbstractCrudObject} from './../abstract-crud-object';

/**
 * ExternalMerchantSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
export default class ExternalMerchantSettings extends AbstractCrudObject {
  static get Fields (): Object {
    return Object.freeze({
      connect_woo: 'connect_woo',
      external_platform: 'external_platform',
      id: 'id',
    });
  }


  
  get (fields: Array<string>, params: Object = {}): ExternalMerchantSettings {
    // $FlowFixMe : Support Generic Types
    return this.read(
      fields,
      params
    );
  }
}
